<app-base-template>
  <div>
    <div class="stepper-list">
      <app-stepper-circle-progress icon="warning" />
    </div>
    <h1 translate>pages.disconnected.title</h1>
    <h2 translate>pages.disconnected.subtitle</h2>
  </div>
  <p translate>pages.disconnected.description</p>
</app-base-template>
